// buttons don't inherit the font and the text color without the tailwind preflight
export const buttonResetClassName =
  'border-0 bg-transparent p-0 text-left font-approach-light text-inherit'

export const separatorClassName = 'm-0 h-px w-full shrink-0 border-0 bg-lightGrey/30'
